<script>
	import { onMount } from "svelte";
	
	let decor;
	let scrolledBefore = 0;
	let transform = () => {};
	
	function animateDecor() {
		// right Page of "Now" container. So actual displayed page:
		const rightContainer = document.querySelector('.container > .right');
		const scrolled = rightContainer ? rightContainer.scrollTop : 0;
		if(scrolledBefore !== scrolled) {
			transform = (factor) => {
				return `translateY(${Math.max(-200, scrolled * factor)}px)`;
			}
		}
		scrolledBefore = scrolled;
		requestAnimationFrame(animateDecor);
	}
	function decorInNowPage(element) {
		if(!element.parentElement) {
			return false;
		}
		return element.parentElement.classList.contains('now') || decorInNowPage(element.parentElement);
	}
	
	onMount(() => {
		if(decorInNowPage(decor)) {
			animateDecor();
		}
	})
</script>

<div class="decor" bind:this={decor}>
	<svg class="big" style="transform: {transform(-1)}"
		 xmlns="http://www.w3.org/2000/svg" width="196.455" height="195.846" viewBox="0 0 196.455 195.846">
		<path id="Pfad_3559" data-name="Pfad 3559" d="M18616.264-22266.242l106.168-16.723,50.145,97.227-76.488,76.086-97.539-49.141Z" transform="translate(-21494.617 19477.689) rotate(8)" fill="#8f5b50"/>
	</svg>
	<svg class="middle" style="transform: {transform(-.75)}"
		 xmlns="http://www.w3.org/2000/svg" width="134.474" height="134.074" viewBox="0 0 134.474 134.074">
		<path id="Pfad_3558" data-name="Pfad 3558" d="M18610.52-22271.666l71.744-11.3,33.887,65.705-51.687,51.414-65.912-33.209Z" transform="translate(-14883.749 24936.477) rotate(-9)" fill="#a59444"/>
	</svg>
	<svg class="small" style="transform: {transform(-.5)}"
		 xmlns="http://www.w3.org/2000/svg" width="134.623" height="134.73" viewBox="0 0 134.623 134.73">
		<path id="Pfad_3560" data-name="Pfad 3560" d="M18608.445-22273.625l59.307-9.34,28.012,54.314-42.727,42.5-54.486-27.451Z" transform="matrix(0.559, 0.829, -0.829, 0.559, -28793.33, -2958.423)" fill="#e1e1db"/>
	</svg>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		height: fit-content;
		margin: 0;
		padding: 0;
	}
	
	.decor {
		width: 45%;
		position: absolute;
		height: 12vmax;
		top: -15px;
		right: 0;
		z-index: -1;

		> svg {
			position: absolute;

			&.big {
				right: 0;
				width: 50%;
				top: 0;
				height: auto;
			}
			&.middle {
				left: 0;
				width: 35%;
				top: 50%;
				height: auto;
			}
			&.small {
				left: 30%;
				width: 30%;
				top: 100%;
				height: auto;
			}
		}
		
		@include for-tablet-portrait-up {
			width: 25%;
			right: 15vw;
		}
		
		@include for-tablet-landscape-up {
			width: 20%;
		}
	}

</style>
